import * as React from "react";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";

// styles
import { styles } from "./RelativeView.styles";

export interface DisplayData<T> {
  type: string;
  payload: T;
}

export type DataMapper<T> = (data: T) => JSX.Element | null;

export interface RelativeViewProps<T> extends WithStyles<typeof styles> {
  className?: string;
  displayData: DisplayData<T>[];
  dataMappers: Record<string, DataMapper<T>>;
}

export interface RelativeViewState {}

class RelativeViewComponent<T> extends React.Component<RelativeViewProps<T>, RelativeViewState> {
  constructor(props: RelativeViewProps<T>) {
    super(props);

    this.state = {};
  }

  private renderData() {
    const { displayData, dataMappers } = this.props;

    return displayData.map(({ type, payload }, i) => (
      <React.Fragment key={i}>{dataMappers[type](payload)}</React.Fragment>
    ));
  }

  public render() {
    return (
      <div
        className={`${this.props.classes.container}${
          this.props.className ? ` ${this.props.className}` : ""
        }`}
      >
        {this.renderData()}
        {this.props.children}
      </div>
    );
  }
}

export const RelativeView = withStyles(styles)(RelativeViewComponent);
